import { Tooltip } from '@mui/material';
import TrackChangesIcon from '@mui/icons-material/TrackChanges';

export default function PreMatchedChip() {
  return (
    <Tooltip title="This alert was pre-matched to an order by automation. Check Order URL field for more details." arrow>
      <TrackChangesIcon sx={{ color: '#d97706', fontSize: '20px' }} />
    </Tooltip>
  );
}
